import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const LOGO_SRC = `${process.env.PUBLIC_URL || ""}/rdvmarket-icon.svg`;

/**
 * Logo RdvMarket (icône R + point bleu) — sidebar, navbar, auth.
 */
export default function BrandLogo({
  className,
  linkClassName,
  size = "md",
  showWordmark = false,
  wordmarkClassName,
  to,
  onClick,
  "data-testid": testId,
}) {
  const box =
    size === "sm"
      ? "h-9 w-9"
      : size === "lg"
        ? "h-11 w-11"
        : "h-10 w-10";

  const img = (
    <img
      src={LOGO_SRC}
      alt=""
      width={size === "sm" ? 36 : size === "lg" ? 44 : 40}
      height={size === "sm" ? 36 : size === "lg" ? 44 : 40}
      className={cn("shrink-0 object-contain", box, className)}
      aria-hidden
    />
  );

  const wordmark = showWordmark ? (
    <span
      className={cn(
        "font-display font-bold tracking-tight truncate",
        wordmarkClassName,
      )}
    >
      RdvMarket
    </span>
  ) : null;

  const inner = (
    <>
      {img}
      {wordmark}
    </>
  );

  const wrapClass = cn(
    "inline-flex min-w-0 items-center gap-2.5 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-[#2D7FF9]/40 focus-visible:ring-offset-2 ring-offset-[#0f172a]",
    showWordmark && "gap-2.5",
    linkClassName,
  );

  if (to) {
    return (
      <Link to={to} onClick={onClick} className={wrapClass} data-testid={testId}>
        {inner}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={wrapClass} data-testid={testId}>
        {inner}
      </button>
    );
  }

  return (
    <span className={wrapClass} data-testid={testId}>
      {inner}
    </span>
  );
}
